<template>
  <el-dialog
    :visible="visible"
    custom-class="ssmQuestion"
    :show-close="false"
    width="430px"
    top="35vh"
    center>
  <div id="ssmQuestion">
    <div class="answer">
      <div class="title">
        <img src="@/assets/image/AllGame/gameDetails/sell.png" alt="">
      </div>
      <div class="text">
        须等待卖家上线沟通
      </div>
      <div class="chat" @click="goCusSell()">
        <img src="@/assets/image/AllGame/gameDetails/sell_chat.png" alt="">
      </div>
    </div>
    <div class="answer">
      <div class="title">
        <img src="@/assets/image/AllGame/gameDetails/curs.png" alt="">
      </div>
      <div class="text">
        由官方客服联系卖家
      </div>
      <div class="chat" @click="goCusChat()">
        <img src="@/assets/image/AllGame/gameDetails/cus_chat.png" alt="">
      </div>
    </div>
    <img class="close" src="@/assets/image/AccountDeal/close.png" alt="" @click="$emit('update:visible', false)">
  </div>
</el-dialog>
</template>

<script>
export default {
  name: 'buyerToSellOnChat',
  props:{
    visible:{
      type:Boolean,
      default: false
    },
  },
  data() {
    return {
      
    }
  },
  methods: {
    goCusSell() {
      this.$emit('cusSell')
    },
    goCusChat() {
      this.$emit('update:visible', false)
      this.$emit('cusSers')
    }
  }
}
</script>

<style lang="less" scoped>
/deep/.ssmQuestion {
  border-radius: 4px;

  .el-dialog__header, .el-dialog__body {
    padding: 0 !important;
  }

  #ssmQuestion {
    position: relative;
    padding: 36px 30px;
    display: flex;
    

    .answer {
      // flex: 1;
      width: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      &:first-child{
        border-right: 1px solid #F4F4F4;
      }

      .title {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 113px;
        img{
          width: 155px;
          height: 113px;
        }
      }

      .text {
        margin-top: 13px;
        font-size: 14px;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 400;
        color: #000000;
        text-align: center;
      }
      
      .chat{
        margin-top: 14px;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        img{
          width: 99px;
          height: 29px;
        }
      }
    }
    .close {
      position: absolute;
      width: 30px;
      height: 30px;
      bottom: -40px;
      left: calc(50% - 15px);
      cursor: pointer;
    }
  }
}
</style>